import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Public Pages
import { Home } from "./pages/Home";
import { Planos } from "./pages/Planos";
import { Login } from "./pages/auth/Login";
import { Register } from "./pages/auth/Register";

// Onboarding Pages
import { SelectPlan } from "./pages/onboarding/SelectPlan";
import { Payment } from "./pages/onboarding/Payment";

// Dashboard (Admin)
import { Dashboard } from "./pages/dashboard/Dashboard";
import { Users } from "./pages/dashboard/Users";
import { Invoices } from "./pages/dashboard/Invoices";
import { PlansAdmin } from "./pages/dashboard/Plans";
import { Tickets } from "./pages/dashboard/Tickets";

// Client Portal
import { ClientDashboard } from "./pages/client/Dashboard";
import { ClientProfile } from "./pages/client/Profile";
import { ClientSubscription } from "./pages/client/Subscription";
import { ClientInvoices } from "./pages/client/Invoices";
import { ClientSupport } from "./pages/client/Support";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/planos" element={<Planos />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Register />} />

            {/* Onboarding Routes */}
            <Route path="/onboarding/plano" element={<SelectPlan />} />
            <Route path="/onboarding/pagamento" element={<Payment />} />

            {/* Admin Routes */}
            <Route path="/admin/dashboard" element={
              <ProtectedRoute requireAdmin>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute requireAdmin>
                <Users />
              </ProtectedRoute>
            } />
            <Route path="/admin/invoices" element={
              <ProtectedRoute requireAdmin>
                <Invoices />
              </ProtectedRoute>
            } />
            <Route path="/admin/plans" element={
              <ProtectedRoute requireAdmin>
                <PlansAdmin />
              </ProtectedRoute>
            } />
            <Route path="/admin/tickets" element={
              <ProtectedRoute requireAdmin>
                <Tickets />
              </ProtectedRoute>
            } />

            {/* Client Routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <ClientDashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/perfil" element={
              <ProtectedRoute>
                <ClientProfile />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/assinatura" element={
              <ProtectedRoute>
                <ClientSubscription />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/faturas" element={
              <ProtectedRoute>
                <ClientInvoices />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/suporte" element={
              <ProtectedRoute>
                <ClientSupport />
              </ProtectedRoute>
            } />

            {/* Legacy Dashboard Redirect */}
            <Route path="/dashboard-old" element={<Navigate to="/dashboard" replace />} />

            {/* 404 */}
            <Route path="*" element={
              <div className="min-h-screen flex items-center justify-center bg-background-light">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-neutral-900 mb-4">404</h1>
                  <p className="text-neutral-600 mb-6">Página não encontrada</p>
                  <a href="/" className="text-primary-blue font-bold hover:underline">
                    Voltar para a página inicial
                  </a>
                </div>
              </div>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
